import React, { useState } from "react";
import icons from "../lib/icons";

const CopyButton = ({ copyText }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(copyText);

    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 1500); // Tooltip shows for 1.5 seconds
  };

  return (
    <div className="relative   flex  h-full ">
      <button
        className="dark-btn flex items-center gap-1 mr-auto"
        onClick={(e) => handleCopy(e)}
      >
        <p>کپی</p>
        <img src={icons.list} alt="edit-icon" width={16} height={16} />
      </button>
      {showTooltip && (
        <div className="absolute   left-1/2 transform -translate-x-1/2 mb-2 bg-gray-800 text-white text-xs px-2 py-1 rounded">
          کپی{`\u202F`}شد
        </div>
      )}
    </div>
  );
};

export default CopyButton;
